(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    const specificForms = document.querySelectorAll('.new-main-products form[action="/cart/add"]');
    const forms = specificForms;
    
    forms.forEach(function(form) {
      form.addEventListener('submit', async function(e) {
        e.preventDefault();
        
        const button = form.querySelector('button[type="submit"]');
        if (!button) return;
        
        const formData = new FormData(form);
        const variantId = formData.get('id');
        const quantity = formData.get('quantity') || 1;
        const sellingPlan = formData.get('selling_plan');
        
        button.disabled = true;
        const originalText = button.innerHTML;
        
        button.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M19 10C19 11.78 18.4722 13.5201 17.4832 15.0001C16.4943 16.4802 15.0887 17.6337 13.4442 18.3149C11.7996 18.9961 9.99002 19.1743 8.24419 18.8271C6.49836 18.4798 4.89471 17.6226 3.63604 16.364C2.37737 15.1053 1.5202 13.5016 1.17293 11.7558C0.825665 10.01 1.0039 8.20038 1.68508 6.55585C2.36627 4.91131 3.51983 3.50571 4.99987 2.51677C6.47991 1.52784 8.21997 1 10 1" stroke="#2E2E24" stroke-width="2" stroke-linecap="round"/></svg>';
        
        setTimeout(() => {
          button.classList.add('loading');
        }, 10);
        
        try {
          const payload = {
            id: variantId,
            quantity: parseInt(quantity.toString())
          };
          
          if (sellingPlan) {
            payload.selling_plan = sellingPlan;
          }
          
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify(payload)
          });
          
          if (!response.ok) {
            throw new Error('Failed to add to cart');
          }
          
          const result = await response.json();
          
          document.dispatchEvent(new CustomEvent('cart:update-counter'));
          
          document.dispatchEvent(new CustomEvent('cart:refresh-open'));
          
          setTimeout(function() {
            button.classList.remove('loading');
            button.innerHTML = '✓ Added!';
            
            setTimeout(function() {
              button.innerHTML = originalText;
              button.disabled = false;
            }, 1000);
          }, 1000);
          
        } catch (error) {
          console.error('[Main Products] Add to cart error:', error);
          alert('Error adding to cart. Please try again.');
          button.classList.remove('loading');
          button.innerHTML = originalText;
          button.disabled = false;
        }
      });
    });
  });

})();
